import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import { optionsMovementCash, optionsTransaction } from '../../constants/app';
import ActionMenu from '../utils/ActionMenu';
import ErrorBoundary from '../utils/ErrorBoundary';

function ItemRow(props) {
    const { item, onEditArticle, deleteArticle, isMobile, history } = props;
    const actions = [
        { name: 'Редактирование', icon: 'flaticon2-contract', action: () => onEditArticle(item) },
        { name: 'Удалить', icon: 'flaticon2-trash', action: () => deleteArticle(item)}
    ];

    const transactionOption = optionsTransaction.find(option => option.value === item.typeTransaction);
    const movementCashOption = optionsMovementCash.find((option) => option.value === item.typeMovementCash);

    if (isMobile) return (
        <tr key={item.id} className="kt-datatable__row">
            <div className='mobile_div_flex column padding10px'>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex gap0px' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>{`Время: ${item.created_at}`}</span>
                    </div>
                    <div className='mobile_div_flex gap0px' style={{ width: '50%', justifyContent: 'flex-end' }}>
                        {!item.refunded && !item.refund && !item.notRefunded && <ActionMenu actions={actions}/>}
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <span style={{ color: '#000' }}>{`Операция: ${item.name}`}</span>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>
                            {`Тип транзакции: ${(transactionOption && transactionOption.label) ? transactionOption.label : 'Неизвестно'}`}
                        </span>
                    </div>
                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>
                            {`Тип: ${(movementCashOption && movementCashOption.label) ? movementCashOption.label : 'Неизвестно'}`}
                        </span>
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex' style={{ width: '50%' }}> 
                        <span style={{ color: '#000' }}>{`Сумма: ${item.sum}`}</span>
                    </div>
                    <div className='mobile_div_flex' style={{ width: '50%' }}> 
                        <span style={{ color: '#000' }}>{`Автор: ${item.author}`}</span>
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <span style={{ color: '#000' }}>{`Примечание: ${item.comment ? item.comment : ''}`}</span>
                    {item.invoiceId && <button data-tip="Просмотр" className="btn btn-sm btn-clean btn-icon btn-icon-md" onClick={() => history.push(`/accounting/invoice/detail/${item.invoiceId}`)}> <i className='la la-eye'/> </button>}
                </div>                                    
            </div>
        </tr>
    );

    return (
        <tr key={item.id} className="kt-datatable__row" onDoubleClick={() => onEditArticle(item)}>                            
        <td className="kt-datatable__cell" style={{ width: '15%' }}>
            <span>
                {item.created_at}
            </span>
        </td>
        <td className="kt-datatable__cell" style={{ width: '15%' }}>
            <span>
                {item.name}
            </span>
        </td>
        <td className="kt-datatable__cell" style={{ width: '10%' }}>
            <span>
                {(transactionOption && transactionOption.label) ? transactionOption.label : 'Неизвестно'}
            </span>
        </td>
        <td className="kt-datatable__cell" style={{ width: '10%' }}>
            <span>
                {(movementCashOption && movementCashOption.label) ? movementCashOption.label : 'Неизвестно'}
            </span>
        </td>                           
        <td className="kt-datatable__cell" style={{ width: '10%', minWidth: '100px' }}>
            <span>
                {item.sum}
            </span>
        </td>
        <td className="kt-datatable__cell" style={{ width: '15%' }}>
            <span>
                {item.author}
            </span>
        </td>
        <td className="kt-datatable__cell" style={{ display: 'flex'}}>
            <span>
                {item.comment}
            </span>
            {item.invoiceId && <button data-tip="Просмотр" className="btn btn-sm btn-clean btn-icon btn-icon-md" onClick={() => history.push(`/accounting/invoice/detail/${item.invoiceId}`)}> <i className='la la-eye'/> </button>}
        </td>
        <td className="kt-datatable__cell" style={{ width: '115px' }}>
            {!item.refunded && !item.refund && !item.notRefunded && <ActionMenu actions={actions}/>}
        </td>
    </tr>
    )
}

class WorkingShiftArticlesTable extends Component {
    renderThead() {
        return (
            <thead className="kt-datatable__head" style={{ backgroundColor: '#f7f7f7' }}>
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Время</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Операция</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Тип транзакции</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Тип</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px', minWidth: '100px'  }}>
                        <span style={{ color: '#000' }}>Сумма</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Пользователь</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Примечание</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '115px' }}></th>
                </tr>
            </thead>
        );
    }
    
    renderBody(isMobile) {
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.filter((item) => {
                    let check = true;

                    if (this.props.filters && this.props.filters.name) check = check && (item.name === this.props.filters.name.label);
                    if (this.props.filters && this.props.filters.typeMovementCash) check = check && (item.typeMovementCash === this.props.filters.typeMovementCash.value);
                    if (this.props.filters && this.props.filters.typeTransaction) check = check && (item.typeTransaction === this.props.filters.typeTransaction.value);

                    return check;
                    })
                    .map((item) => (
                        <ErrorBoundary key={item.id} fallback={<tr className='kt-datatable__row'>{`Не удалось отобразить статью id: ${item.id}. Попробуйте позже.`}</tr>}>
                            <ItemRow history={this.props.history} item={item} isMobile={isMobile} deleteArticle={this.props.deleteArticle} onEditArticle={this.props.onEditArticle}/>
                        </ErrorBoundary>
                    ))
                }
            </tbody>
        );
    }

    render() {
        const isMobile = window.innerWidth <= 900;
        
        if (this.props.items.length === 0) {
            return (
                <div></div>
            );
        }
        
        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {!isMobile && this.renderThead()}
                {this.renderBody(isMobile)}
            </table>
        );
    }
}

export default withRouter(WorkingShiftArticlesTable);